import React, { Fragment } from "react";
import ECLInteger from "../ECLObjectBlock/Inputs/ECLInteger";
import ECLFloat from "../ECLObjectBlock/Inputs/ECLFloat";
import ECLDuration from "../ECLObjectBlock/Inputs/ECLDuration";
import ECLInterval from "../ECLObjectBlock/Inputs/ECLInterval";
import {
   ECLDateTimePicker,
   ECLRange,
   ECLSelect,
   ECLTextInput,
   ECLThemeImage,
} from "../../../index";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { v4 } from "uuid";
import ECLImageUploader from "../../../ECLInputs/ECLImageUploader/ECLImageUploader";
import ECLRichTextEditorFormless from "../../../Widgets/ECLRichText/ECLRichTextEditor/ECLRichTextEditorFormless";

export default function ECLFormInputs(props) {
   const inputBox = useSelectorId();

   function addLinkInstance(property, parent = "") {
      props.setLinks(() => {
         let newLinkArray;
         const newInstance = v4();
         //If it's not a root property, match l.parent with passed in parent
         if (!property.root) {
            newLinkArray = props.links.map((l) => {
               if (l.parent == parent) {
                  const newInstances = [...l.instances];
                  newInstances.push(newInstance);
                  return {
                     ...l,
                     instances: newInstances,
                  };
               } else {
                  return l;
               }
            });
         } else {
            //Otherwise root properties match with property.internalID
            newLinkArray = props.links.map((l) => {
               if (l.parent === property.internalID) {
                  const newInstances = [...l.instances];
                  newInstances.push(newInstance);
                  return {
                     ...l,
                     instances: newInstances,
                  };
               } else {
                  return l;
               }
            });
         }
         //Add the new instance as a parent, so that you may add new instances under it.
         newLinkArray.push({
            parent: newInstance,
            instances: [v4()],
            root: false,
         });

         return newLinkArray;
      });
   }

   function getInstanceChildren(instance) {
      //Gotta do something here
      let instancesToPurge = [instance];
      let theBigFilter = [instance];
      while (instancesToPurge.length > 0) {
         //find item, return children
         let purging = props.links.find(
            (l) => l.parent === instancesToPurge.at(-1),
         );
         if (purging) {
            purging.instances.forEach((i) => {
               theBigFilter.push(i);
               instancesToPurge.unshift(i);
            });
         }
         instancesToPurge.pop();
      }
      return theBigFilter;
   }

   function removeLinkInstance(instance) {
      props.setLinks(() => {
         //Remove the instance, as well as all of the children.  Left as a trivial excersize for the developer.
         //So first find link that holds the instance
         const linkIndex = props.links.findIndex((l) =>
            l.instances.includes(instance),
         );
         //with that link index, we can start modifying the props.links, removing the desired instance from it's array
         const newLinkArray = props.links.map((l, i) => {
            if (i === linkIndex) {
               return {
                  ...l,
                  instances: l.instances.filter((m) => m !== instance),
               };
            } else {
               return l;
            }
         });
         //Then we need to walk through the new link array, removing any child links.
         const children = getInstanceChildren(instance);
         return newLinkArray.filter((l) => !children.includes(l.parent));
      });
      //NEED TO UPDATE SERVER STATE BY DELETING KEYS TODODODODODODODODODODODODODODODODODODODODDO
   }
   return props.object.properties.map((p, i) => {
      if (p.link) {
         if (p.ownsData) {
            return (
               <div
                  className="form-object-container"
                  id={`object-container-${inputBox}`}
                  key={i}
               >
                  <div className="form-object-combo-header">
                     <label
                        className="form-object-label"
                        htmlFor={"fieldset-" + inputBox}
                     >
                        {p.name}
                     </label>
                     {p.ownsData && p.type.backlink && (
                        <button
                           onClick={(e) => {
                              e.preventDefault();
                              addLinkInstance(p, props.parent);
                           }}
                        >
                           <ECLThemeImage fontAwesome="plus" />
                        </button>
                     )}
                  </div>
                  {props.links
                     .find((l) =>
                        p.root
                           ? l.parent === p.internalID
                           : l.parent === props.parent,
                     )
                     .instances.map((instance, count) => {
                        return (
                           <fieldset
                              id={"fieldset-" + inputBox}
                              key={instance}
                              data-object={p.UUID}
                              data-count={count}
                           >
                              <div className="form-object-instance-combo">
                                 <div className="form-input-fieldset-container">
                                    <ECLFormInputs
                                       object={p.link}
                                       objectParent={props.object}
                                       links={props.links}
                                       setLinks={props.setLinks}
                                       parent={instance}
                                       count={count}
                                       lineage={
                                          props.lineage + "--" + p.link.UUID
                                       }
                                       sessionState={props.sessionState}
                                    />
                                 </div>
                                 {p.type.backlink && (
                                    <button
                                       onClick={(e) => {
                                          e.preventDefault();
                                          removeLinkInstance(instance);
                                       }}
                                    >
                                       <ECLThemeImage fontAwesome="xmark" />
                                    </button>
                                 )}
                              </div>
                           </fieldset>
                        );
                     })}
               </div>
            );
         } else {
            return (
               <div id={`object-container-${inputBox}`} key={i}>
                  <label>{p.name}</label>
                  <ECLSelect
                     id={`input-${inputBox}-${p.UUID}`}
                     options={
                        props.links.find((l) =>
                           p.root
                              ? l.parent === p.internalID
                              : l.parent === props.parent,
                        ).selectState
                     }
                     setOptions={(updatedArray) => {
                        props.setLinks(
                           props.links.map((l) => {
                              if (
                                 p.root
                                    ? l.parent === p.internalID
                                    : l.parent === props.parent
                              ) {
                                 return {
                                    ...l,
                                    selectState: updatedArray,
                                 };
                              }
                              return l;
                           }),
                        );
                     }}
                     multiselect={p.type.backlink}
                  />
               </div>
            );
         }
      } else {
         switch (p.type.primitive) {
            case "integer":
               if (
                  p.type.minimum_value !== undefined &&
                  p.type.maximum_value !== undefined
               ) {
                  return (
                     <ECLRange
                        id={`input-${inputBox}-${p.UUID}`}
                        key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                        name={p.name}
                        precision={0}
                        min={p.type.minimum_value}
                        max={p.type.maximum_value}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  );
               }
               return (
                  <Fragment
                     key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                  >
                     <ECLInteger
                        id={`input-${inputBox}-${p.UUID}`}
                        name={p.name}
                        min={p.type.minimum_value}
                        max={p.type.maximum_value}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  </Fragment>
               );
            case "double":
               if (
                  p.type.minimum_value !== undefined &&
                  p.type.maximum_value !== undefined
               ) {
                  return (
                     <ECLRange
                        id={`input-${inputBox}-${p.UUID}`}
                        key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                        name={p.name}
                        precision={2}
                        min={p.type.minimum_value}
                        max={p.type.maximum_value}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  );
               }
               return (
                  <Fragment
                     key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                  >
                     <ECLFloat
                        id={`input-${inputBox}-${p.UUID}`}
                        name={p.name}
                        min={p.type.minimum_value}
                        max={p.type.maximum_value}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  </Fragment>
               );
            case "duration":
               return (
                  <Fragment
                     key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                  >
                     <ECLDuration
                        id={`input-${inputBox}-${p.UUID}`}
                        name={p.name}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  </Fragment>
               );
            case "interval":
               return (
                  <Fragment
                     key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                  >
                     <ECLInterval
                        id={`input-${inputBox}-${p.UUID}`}
                        name={p.name}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  </Fragment>
               );
            case "timestamp":
               return (
                  <Fragment
                     key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                  >
                     <ECLDateTimePicker
                        id={`input-${inputBox}-${p.UUID}`}
                        name={p.name}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  </Fragment>
               );
            case "text":
               if (p.type.show_as_rich_text) {
                  return (
                     <div
                        key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                     >
                        <label>{p.name}</label>
                        <ECLRichTextEditorFormless
                           omitSubmit={true}
                           id={`input-${inputBox}-${p.UUID}`}
                        />
                     </div>
                  );
               }
               return (
                  <Fragment
                     key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                  >
                     <ECLTextInput
                        id={`input-${inputBox}-${p.UUID}`}
                        name={p.name}
                        value={
                           props.sessionState?.[
                              `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                           ]
                              ? props.sessionState[
                                   `${props.lineage}--${p.name.replaceAll(" ", "_")}`
                                ]
                              : null
                        }
                     />
                  </Fragment>
               );

            case "image":
               return (
                  <Fragment
                     key={`${props.parent}--${p.name.replaceAll(" ", "_")}`}
                  >
                     <ECLImageUploader id={`input-${inputBox}-${p.UUID}`} />
                  </Fragment>
               );
         }
      }
   });
}
